import { render, staticRenderFns } from "./Szlqd.vue?vue&type=template&id=6922db15&scoped=true"
import script from "./Szlqd.vue?vue&type=script&lang=js"
export * from "./Szlqd.vue?vue&type=script&lang=js"
import style0 from "./Szlqd.vue?vue&type=style&index=0&id=6922db15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922db15",
  null
  
)

export default component.exports